import zenscroll from 'zenscroll';

/**
 * @param scrollDuration
 * @param selector
 */
export function scrollToTopEffect(scrollDuration: number, selector: string) {
    const element = document.querySelector(selector);
    if (element) {
        zenscroll.to(element, scrollDuration);
    } else {
        console.warn(`Could not smooth-scroll to ${selector} as the element was not found`);
    }
}

/**
 * @param scrollDuration
 * @param selector
 * @param offset
 */
export function scrollToTopOffsetEffect(scrollDuration: number, selector: string, offset: number) {
    const element = document.querySelector(selector);
    if (element) {
        const y = zenscroll.getTopOf(element);
        zenscroll.toY(y + offset, scrollDuration);
    } else {
        console.warn(`Could not smooth-scroll (with offset) to ${selector} as the element was not found`);
    }
}
